<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext pb-55">
      <div class="container pb-0">
        <div class="area_wrap">
          <div class="text_wrap caution care">
            <div class="tw_detail">
              <div class="tw_item">
                <div class="tw_title">
                  <h2>갑상선 수술 후 식이요법</h2>
                </div>
                <div class="tw_content">
                  <span>갑상선암이나 종양으로 갑상선 수술하신 분들이 자주 물어보시는
                    질문 중 하나가 식이요법입니다. 갑상선은 갑상선호르몬을 만드는
                    기관인데, 음식에 들어 있는 요오드는 갑상선호르몬을 만드는
                    주된 원료입니다. 갑상선 전절제술을 받으신 분은 갑상선호르몬을
                    약(갑상선호르몬제; 신지로이드 또는 신지록신)으로 보충하기
                    때문에, 음식으로 섭취하는 요오드에 대해 특별히 신경 쓸 필요
                    없습니다.
                  </span>
                  <div class="tw_sub asterisk">
                    <span class="red">갑상선 전절제술을 받은 경우: 요오드 섭취에 제한이 없습니다.</span>
                  </div>
                  <div class="content_sub">
                    <span>갑상선이 절반 제거된 반절제술을 받으신 경우에는 요오드 섭취에
                          대해 관리가 필요합니다. 우리나라 성인의 하루 평균 요오드
                          섭취량은 하루 840ug 정도로 권장섭취량(하루 150ug)의 5배
                          이상을 섭취하고 있어 요오드 섭취가 부족한 경우는 흔하지
                          않습니다. 해산물 등 음식에 요오드 가 많이 함유되어 있어서
                          그렇습니다. 그런데 일반적으로 요오드 섭취가 부족하면
                          갑상선기능항진증, 요오드 섭취가 과하면 갑상선기능 저하증과
                          갑상선염이 잘 발생되는 것으로 알려져 있습니다. 따라서 갑상선
                          반절제술을 받으신 경우, 과도한 요오드 섭취는 피하시는 것이
                          좋습니다.
                    </span>
                  </div>
                  <div class="tw_sub asterisk">
                    <span class="red">갑상선 반절제술을 받은 경우: 남아있는 절반의 갑상선의
                                      기능을 잘 유지하기 위해서는 요오드 섭취를 너무 많이 하는 것은
                                      좋지 않습니다.
                    </span>
                  </div>
                  <div class="tw_sub bar">
                    <span class="red">
                      요오드는 해조류, 어패류, 건어물류에 많이 들어있으니,
                        이런 것은 너무 많이 드시지 말기 바랍니다.
                    </span>
                    <span class="red">
                      국을 끓일 때 다시마나 멸치로 국물을 우리지 않는 것이 좋습니다.
                    </span>
                    <span class="red">
                      특히, 미역국은 한 달에 한 번 정도 먹는 것을 권장합니다.
                    </span>
                  </div>
                </div>
              </div>
              <div class="tw_item last">
                <div class="tw_title">
                  <h2>갑상선호르몬제 복용 방법</h2>
                </div>
                <div class="tw_content pb-23">
                  <span>갑상선 수술 후 혹은 수술과 관계없이 생긴 갑상선기능저하증
                        때는 갑상선호르몬제를 복용해야 합니다. 갑상선호르몬제
                        (신지로이드, 신지록신, 테트로닌)를 복용할 때
                        유의점을 알려드립니다.
                  </span>
                  <div class="tw_sub bar">
                    <span class="red">
                      갑상선호르몬제는 하루 1회, 공복상태에서 물과 함께 복용해야
                      합니다. 아침에 일어나자 마자 복용하는 것이 가장 편한
                      복용법인데, 몇 시에 복용하는지는 중요하지 않고, 공복 상태에서
                      복용하는 것이 중요합니다.
                    </span>
                    <span class="red">
                      갑상선호르몬제의 체내 흡수를 일정하게 유지하기 위해서
                      갑상선호르몬제 복용 후 30분 내지 1시간 정도 공복상태를
                      유지해주어야 합니다. 다른 약이나 영양제, 음식 섭취는 갑상선
                      호르몬제 복용과 시간을 두고 드시기 바랍니다.
                    </span>
                    <span class="red">
                      병원에 내원해서 갑상선기능검사(혈액검사)를 하는 날에는
                      아침에 갑상선호르몬제를 복용 하지 않은 상태로 오셔서 검사
                      받아야 합니다. 당일 갑상선호르몬제는 채혈 후에 드시면 됩니다.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
export default {
  data () {
    return {
      transDate: {
        headerName: '수술 후 관리',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
